<template>
    <div class="p-grid p-mx-auto p-mt-2">
        <div class="p-col-12 p-md-4 p-mx-auto">
            <Dropdown class="p-col-12 p-md-12 p-text-left" placeholder="Select Category"
                v-model="selectedCategory"
                @change="ssCategoryChanged()"
                :options="categoryLinks.items" :loading="categoryLinks.isLoading"
                optionLabel="ssCategoryContainer.name"
                :filter="true" filterPlaceholder="Find Category" />
        </div>
        <div class="p-col-12 p-md-2">
            <div v-if="selectedCategory !== undefined && selectedCategory !== null" class="p-col-12">
                <div class="p-col-12 p-md-12">
                    <Button label="<" 
                        @click="previousCategory()"
                        class="p-button-md p-button-outlined p-button-secondary" />

                    <Button label=">" 
                        @click="nextCategory()"
                        class="p-button-md p-ml-2 p-button-outlined p-button-secondary" />
                </div>

                <Textarea
                    v-model="selectedCategory.ssCategoryContainer.comment"
                    rows="2" :autoResize="true"
                    placeholder="Category Comment" class="p-col-12" id="comment" />
                <br/>
                <Checkbox id="is_category_active" :binary="true" class="p-mr-2 p-mt-2"
                    v-model="selectedCategory.ssCategoryContainer.isActive" />
                <label for="is_category_active">Active</label>
                <Button label="Save" @click="saveCategory()" :loading="selectedCategory.isLoading" class="p-ml-6 p-mt-2" />
            </div>
        </div>
        <div class="p-col-12 p-md-4 p-mx-auto">
            <Dropdown v-if="selectedCategory !== undefined && selectedCategory !== null"
                class="p-col-12 p-md-12 p-text-left" placeholder="Select Category"
                :disabled="true"
                v-model="selectedCategory"
                @change="mkCategoryChanged()"
                :options="categoryLinks.items" :loading="categoryLinks.isLoading"
                optionLabel="mkAreaContainer.name" />
        </div>
    </div>

    <div v-if="selectedCategory !== undefined && selectedCategory !== null 
            && selectedCategory.ssCategoryContainer !== undefined
            && selectedCategory.ssCategoryContainer !== null
            && selectedCategory.ssCategoryContainer.uniqueTournaments !== undefined
            && selectedCategory.ssCategoryContainer.uniqueTournaments !== null
            && selectedCategory.ssCategoryContainer.uniqueTournaments.length > 0">
        <div class="p-grid p-mx-auto p-mt-2">
            <div class="p-col-12 p-md-4 p-mx-auto">
                <Dropdown v-model="tournamentLink.ssUniqueTournamentId"
                    placeholder="Select Unique Tournament"
                    :options="selectedCategory.ssCategoryContainer.uniqueTournaments"
                    optionLabel="name" optionValue="id"
                    @change="ssUniqueTournamentChanged()"
                    class="p-col-12 p-md-12 p-text-left"
                    :filter="true" />

                <Button v-show="tournamentLink.ssUniqueTournamentId !== null && tournamentLink.ssUniqueTournamentId !== undefined"
                    label="Get Teams"
                    @click="getSSTeams()"
                    :disabled="teamLink.isLoadingSSTeams"
                    class="p-button-md p-button-raised p-button-primary p-mt-4" />
            </div>
            <div class="p-col-12 p-md-2">
                <div v-show="tournamentLink.ssUniqueTournamentId !== undefined
                            && tournamentLink.ssUniqueTournamentId !== null"
                    class="p-col-12 p-text-left p-mt-6">
                    <Textarea v-model="tournamentLink.comment" rows="2" :autoResize="true"
                        placeholder="Tournament Comment" class="p-col-12" id="comment" />
                    <br/>
                    <Checkbox id="is_unique_tournament_active" :binary="true" class="p-mr-2 p-mt-2"
                        v-model="tournamentLink.isActive" />
                    <label for="is_unique_tournament_active">Active</label>
                    <Button label="Save" @click="saveUniqueTournament()" :loading="tournamentLink.isLoading" class="p-ml-6 p-mt-2" />
                </div>
            </div>
            <div class="p-col-12 p-md-4 p-mx-auto">
                <Dropdown v-model="tournamentLink.mkCompetitionId"
                    placeholder="Select Competition"
                    :options="selectedCategory.mkAreaContainer.competitions"
                    optionLabel="name" optionValue="id"
                    @change="mkCompetitionChanged()"
                    class="p-col-12 p-md-12 p-text-left"
                    :filter="true" />

                <Button v-show="tournamentLink.mkCompetitionId !== null && tournamentLink.mkCompetitionId !== undefined"
                    label="Get Teams"
                    @click="getMKTeams()"
                    class="p-button-md p-button-raised p-button-primary p-mt-4" />
            </div>
        </div>

        <div class="p-grid p-mx-auto p-mt-2">
            <div class="p-col-12 p-md-4 p-mx-auto">
                <div v-if="tournamentLink.ssTeams !== undefined
                    && tournamentLink.ssTeams !== null
                    && tournamentLink.ssTeams.length > 0
                    && tournamentLink.ssUniqueTournamentId !== undefined
                    && tournamentLink.ssUniqueTournamentId !== null">
                    <span class="p-ml-4">{{tournamentLink.ssTeams.length}} Teams</span>

                    <Listbox v-model="teamLink.ssTeamId"
                        :options="tournamentLink.ssTeams"
                        optionLabel="name" optionValue="id"
                        @change="ssTeamSelected()"
                        class="p-col-12 p-md-12 p-text-left"
                        :filter="true" listStyle="max-height:500px" />
                </div>
            </div>
            <div class="p-col-12 p-md-1 p-mx-auto p-text-center">
                <div v-show="tournamentLink.ssTeams !== undefined && tournamentLink.ssTeams !== null
                    && tournamentLink.ssTeams.length > 0
                    && tournamentLink.mkTeams !== undefined && tournamentLink.mkTeams !== null
                    && tournamentLink.mkTeams.length > 0">
                    <div class="p-col-12 p-md-12"></div>

                    <Button label="Match Teams" 
                        :disabled="teamLink.isLoadingSSTeams || teamLink.isLoadingMKTeams"
                        @click="createTeamLink()"
                        style="margin-top:100px;"
                        class="p-button-lg p-button-raised p-button-primary" />

                    <Button label="Remove Link" 
                        :disabled="(teamLink.isLoadingSSTeams || teamLink.isLoadingMKTeams 
                            || teamLink.ssTeamId === undefined || teamLink.ssTeamId === null
                            || teamLink.mkTeamId === undefined || teamLink.mkTeamId === null)"
                        @click="removeTeamLink()"
                        class="p-button-lg p-button-outlined p-button-danger"
                        style="margin-top: 150px" />
                </div>
            </div>
            <div class="p-col-12 p-md-4 p-mx-auto">
                <div v-if="tournamentLink.mkTeams !== undefined && tournamentLink.mkTeams !== null
                    && tournamentLink.mkTeams.length > 0
                    && tournamentLink.mkCompetitionId !== undefined && tournamentLink.mkCompetitionId !== null">
                    <span class="p-ml-4">{{tournamentLink.mkTeams.length}} Teams</span>

                    <Listbox v-model="teamLink.mkTeamId"
                        :options="tournamentLink.mkTeams"
                        optionLabel="name" optionValue="id"
                        class="p-col-12 p-md-12 p-text-left"
                        :filter="true" listStyle="max-height:500px" />
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import axios from "axios";
import Dropdown from 'primevue/dropdown'
import Button from 'primevue/button'
import Listbox from 'primevue/listbox'
import Checkbox from 'primevue/checkbox'
import Textarea from 'primevue/textarea';

let SpringApi;

export default {
    name: 'SS-MK Team Links',
    components: {
        Dropdown, Button, Checkbox, Listbox, Textarea
    },
    data() {
        return {
            categoryLinks: {
                isLoading: false,
                selected: null,
                items: [],
            },
            selectedCategory: null,
            tournamentLink: {
                isLoading: false,
                ssUniqueTournamentId: null,
                mkCompetitionId: null,
                ssTeams: [],
                mkTeams: [],
                isActive: false,
                comment: null,
            },
            teamLink: {
                isLoading: false,
                isLoadingSSTeams: false,
                isLoadingMKTeams: false,
                ssTeamId: null,
                mkTeamId: null,
            }
        }
    },
    emits: ["loginResult", "pageLoaded"],
    beforeMount() {
        SpringApi = axios.create({
            baseURL : process.env.VUE_APP_SPRING_API_URL,
            headers: {
                'Authorization': 'Bearer ' + this.$cookies.get('token')
            }
        });

        var page = {
            title: "SS-MK Team Links"
        }
        this.$emit('pageLoaded', page)
    },
    mounted() {
        this.getCategoryLinks()
    },
    methods: {
        resetTournamentLink() {
            this.tournamentLink = {
                isLoading: false,
                ssUniqueTournamentId: null,
                mkCompetitionId: null,
                ssTeams: [],
                mkTeams: [],
                isActive: false,
                comment: null,
            };
        },
        resetTeamLink() {
            this.teamLink = {
                isLoading: false,
                isLoadingSSTeams: false,
                isLoadingMKTeams: false,
                ssTeamId: null,
                mkTeamId: null,
            }
        },
        async getCategoryLinks() {
            let categoryLinks = this.categoryLinks;

            categoryLinks.isLoading = true
            let response = await SpringApi.get('/api/links')
            let data = response.data

            categoryLinks.items = data
            categoryLinks.isLoading = false
        },
        previousCategory() {
            let currentSelected = this.selectedCategory
            let currentCategoryId = currentSelected.ssCategoryContainer.id
            for(var i = 0; i < this.categoryLinks.items.length; i++) {
                if (this.categoryLinks.items[i].ssCategoryContainer.id === currentCategoryId 
                    && i > 0) {
                    this.selectedCategory = this.categoryLinks.items[i - 1]
                }
            }
        },
        nextCategory() {
            let currentSelected = this.selectedCategory
            let currentCategoryId = currentSelected.ssCategoryContainer.id
            for(var i = 0; i < this.categoryLinks.items.length; i++) {
                if (this.categoryLinks.items[i].ssCategoryContainer.id === currentCategoryId
                    && i + 1 < this.categoryLinks.items.length) {
                    this.selectedCategory = this.categoryLinks.items[i + 1]
                }
            }
        },
        async saveCategory() {
            let payload = {
                "isActive": this.selectedCategory.ssCategoryContainer.isActive,
                "comment": this.selectedCategory.ssCategoryContainer.comment
            }

            try {
                this.selectedCategory.isLoading = true
                await SpringApi.patch('/api/links/categories/'+this.selectedCategory.ssCategoryContainer.id, payload)
            } catch(error) {
                console.log(error)
            }
            this.selectedCategory.isLoading = false
        },
        ssCategoryChanged() {
            this.resetTournamentLink()
        },
        mkCategoryChanged() {
            this.tournamentLink.mkTeams = []
        },
        async ssUniqueTournamentChanged() {
            this.resetTeamLink()
            this.tournamentLink.ssTeams = []

            try {
                this.tournamentLink.isLoading = true
                let uniqueTournamentLink = await SpringApi.get('/api/links/unique-tournaments/'+this.tournamentLink.ssUniqueTournamentId)
                this.tournamentLink = uniqueTournamentLink.data
            } catch(error) {
                this.tournamentLink.mkCompetitionId = null
            }
            this.tournamentLink.isLoading = false
        },
        async saveUniqueTournament() {
            let payload = {
                "ssCategoryId": this.selectedCategory.ssCategoryContainer.id,
                "isActive": this.tournamentLink.isActive,
                "comment": this.tournamentLink.comment
            }

            try {
                this.tournamentLink.isLoading = true
                await SpringApi.patch('/api/links/unique-tournaments/'+this.tournamentLink.ssUniqueTournamentId, payload)
            } catch(error) {
                console.log(error)
            }
            this.tournamentLink.isLoading = false
        },
        mkCompetitionChanged() {
            this.tournamentLink.mkTeams = []
        },
        async getSSTeams() {
            try {
                this.teamLink.isLoadingSSTeams = true
                this.tournamentLink.ssTeams = null
                let ssTeams = await SpringApi.get('/api/sofascore/teams?ss_unique_tournament_id='+this.tournamentLink.ssUniqueTournamentId)
                this.tournamentLink.ssTeams = ssTeams.data
            } catch(error) {
                console.log(error)
            }
            this.teamLink.isLoadingSSTeams = false
        },
        async getMKTeams() {
            // get mk teams
            // /api/mackolik/teams?competition_id=654
            try {
                this.teamLink.isLoadingMKTeams = true
                this.tournamentLink.mkTeams = null
                let mkTeams = await SpringApi.get('/api/mackolik/teams?competition_id='+this.tournamentLink.mkCompetitionId)
                this.tournamentLink.mkTeams = mkTeams.data
            } catch(error) {
                console.log(error)
            }
            this.teamLink.isLoadingMKTeams = false
        },
        async ssTeamSelected() {
            try {
                this.teamLink.isLoading = true
                let teamLink = await SpringApi.get('/api/links/teams/'+this.teamLink.ssTeamId)
                this.teamLink.mkTeamId = teamLink.data.mkTeamId
            } catch(error) {
                this.teamLink.mkTeamId = null
            }
            this.teamLink.isLoading = false
        },
        async createTeamLink() {
            let payload = {
                "ssCategoryId": this.selectedCategory.ssCategoryContainer.id,
                "mkAreaId": this.selectedCategory.mkAreaContainer.id,
                "ssUniqueTournamentId": this.tournamentLink.ssUniqueTournamentId,
                "mkCompetitionId": this.tournamentLink.mkCompetitionId,
                "mkTeamId": this.teamLink.mkTeamId
            }

            try {
                this.teamLink.isLoading = true
                let createTeamLink = await SpringApi.post('/api/links/teams/'+this.teamLink.ssTeamId, payload)
                this.teamLink.ssTeamId = createTeamLink.data.ssTeamId
                this.teamLink.mkTeamId = createTeamLink.data.mkTeamId
            } catch(error) {
                console.log(error)
            }
            this.teamLink.isLoading = false
        },
        async removeTeamLink() {
            this.$confirm.require({
                message: 'Remove team link?',
                header: 'Remove Link',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Remove',
                rejectLabel: 'Cancel',
                accept: async () => {
                    try {
                        this.teamLink.isLoading = true
                        await SpringApi.delete('/api/links/teams/'+this.teamLink.ssTeamId)
                        this.teamLink.mkTeamId = null
                    } catch(error) {
                        console.log(error)
                    }
                    this.teamLink.isLoading = false
                },
                reject: () => {
                }
            })
        }
    }
}
</script>
